import { ChangeSourceType } from './change-source.type';
import { FormParameters } from './form-parameters.type';

export interface DocumentChangedInfo {
  documentId: string;
  fieldName: string;
  oldValue?: any; // the previous value. It could be the previous change or the field value from document.
  newValue: any; // the value from the change
  formParameters?: FormParameters;
  isInitValue?: boolean;  // flag indicates it is the change for initial or default value
  sourceType?: ChangeSourceType;
  sourceEvent?: ChangeSourceType;
  changedFields?: any[];
  controlName?: string;
  shouldCompareValues?: boolean;
}
